import { Alert } from '../_functions'

document.addEventListener('DOMContentLoaded', function(dom) {
  const object = vnObject

  const form = dom.target.querySelector('.js-form-guide')

  if (form) {

    form.addEventListener('submit', function(e) {
      e.preventDefault()
      e.stopPropagation()

      if (form.checkValidity()) {
        const formData = new FormData(form)
        formData.append('action', 'vn_send_guide')

        const options = {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        }

        fetch(object.ajaxUrl, options)
          .then((response) => response.json())
          .then((res) => {
            form.classList.remove('sending')

            Alert(res.success, res.data.message)

            if (res.success) {
              form.reset()
            }
          })
          .catch((error) => {
            form.classList.remove('sending')
            console.error('Erreur:', error)
          })

        form.classList.add('sending')
        Alert(false, object.formWait)
      } else {
        form.classList.add('was-validated')
      }
    })
  }
})
